import React, {useEffect, useState} from 'react'
import {Col, ControlLabel, Form, FormGroup, Row} from 'react-bootstrap'

import GroupSelector from "../../component/BizGroup/GroupSelector";
import {PermanenceAlertForm} from './CustomAlert/PermanenceAlert/PermancenceAlertForm'
import {CriticalLevelStockForm} from './CustomAlert/StockLevelAlert/CriticalLevelStockForm'
import {InputWithLabel} from '../../component/Form/InputWithLabel'
import Loading from '../../component/Loading/Loading'
import Box from '../../component/Box/Box'
import Page from '../../component/Page/Page'
import FormButtons from '../../component/Form/FormButtons'
import Notify from '../../services/Notify'
import {ALERT_ID, AlertTypeSelector} from './Select/AlertSelect'
import BreadcrumbItem from '../../component/BreadcrumbItem/BreadcrumbItem'
import Switch from "react-switch";
import {AlertConfigurationsService} from '../../services/AlertConfigurationsService';

function AlertsTriggerFormPage({history, match}) {

  const [entity, setEntity] = useState({});
  const [isLoading, setIsLoading] = useState(null);
  const alertConfigurationsService = new AlertConfigurationsService()

  const save = async () => {
    try {
      if (entity.type === ALERT_ID.PERMANENCE_TIME_ALERT && !(entity.durationInHours > 0)) {
        throw new Error("Insira um valor valido para o tempo de permanência")
      }
      setIsLoading(true)
      await alertConfigurationsService.save(entity);
      entity.id ? Notify.success('Configuraçao de Alerta atualizada!') : Notify.success('Configuraçao de Alerta criada!');
      history.goBack();
    } catch (error) {
      entity.id ? Notify.error('Erro ao atualizar alerta', error) : Notify.error('Erro ao criar alerta', error)
    } finally {
      setIsLoading(false)
    }
  }

  const findOneById = async (id) => {
    try {
      setIsLoading(true);
      const newEntity = await alertConfigurationsService.getAlertById(id);
      setEntity(newEntity);
    } catch (e) {
      Notify.error('Erro ao recuperar dados do alerta', e);
    } finally {
      setIsLoading(false);
    }
  }
  const renderFormType = () => {
    switch (entity.type) {
      case ALERT_ID.PERMANENCE_TIME_ALERT:
        return (
          <PermanenceAlertForm
            defaultValue={entity}
            setValue={e => updateField(e)}
          />
        );
      case ALERT_ID.STOCK_LEVEL_CRITICAL_ALERT:
        return (
          <CriticalLevelStockForm
            defaultValue={entity}
            setValue={e => updateField(e)}
          />
        )
    }
  }

  const updateField = (field) => {
    setEntity({...entity, ...field});
  }

  const handleActive = () => {
    updateField({active: !entity.active});
  };

  useEffect(() => {
    if (match.params.id) {
      findOneById(match.params.id)
    }
  }, [match.params && match.params.id])

  return (
    <Page title="Dados do disparo" isLoading={isLoading}
          breadcrumbs={[<BreadcrumbItem title="Lista de alertas" to="/list/alerts-triggers"/>]}>
      <Form className="pb-5 mt-5" onSubmit={e => e.preventDefault() || save()}>
        <Box>
          <Row>
            <Col md={4}>
              <InputWithLabel
                label="Nome"
                defaultValue={entity.friendlyName}
                onChange={e => updateField({friendlyName: e.target.value})}
                required={true}
              />
            </Col>
            <Col md={4}>
              <InputWithLabel
                label="Descrição"
                defaultValue={entity.description}
                onChange={e => updateField({description: e.target.value})}
              />
            </Col>
            <Col md={4}>
              <FormGroup>
                <ControlLabel>Ativo / Inativo</ControlLabel>
                <br/>
                <Switch
                  width={70}
                  checked={entity.active}
                  onChange={handleActive}
                  onColor={'#00cfc3'}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <AlertTypeSelector setValue={e => updateField({type: e})} readonly={match.params.id ? true : false} defaultValue={entity.type}
                                 required/>
            </Col>
            <Col md={4}>
              <GroupSelector multiple setValue={e => updateField({notificationGroups: e})} defaultValue={entity.notificationGroups}
              />
            </Col>
          </Row>
          {
            !entity.type ?
              <Row className="mt-4 mb-5">
                <Col md={12} className="text-center">Selecione um tipo</Col>
              </Row>
              : renderFormType()
          }
          {isLoading ? <Loading/> : <FormButtons history={history}/>}
        </Box>
      </Form>
    </Page>
  )
}

export default AlertsTriggerFormPage;



// WEBPACK FOOTER //
// ./src/pages/Alerts/AlertstriggerFormPage.js